/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarItemsGrid_user = {
    readonly serviceId: string | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItem_user">;
    readonly " $refType": "PdpRespSimilarItemsGrid_user";
};
export type PdpRespSimilarItemsGrid_user$data = PdpRespSimilarItemsGrid_user;
export type PdpRespSimilarItemsGrid_user$key = {
    readonly " $data"?: PdpRespSimilarItemsGrid_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItemsGrid_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSimilarItemsGrid_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItem_user",
      "args": null
    }
  ]
};
(node as any).hash = 'f75bd8f8dbfd2cf0c25719e068ba0cbd';
export default node;
